import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import {
  CUSTOMERS_PATH,
  DEMO_PATH,
  onCustomerSide,
  useCanManageCustomers,
} from "./partnerNav";
import styles from "./styles/PartnerNav.module.css";

/*
  The two contexts a partner can be in, shown in the blue header band where the
  tab row sits for everyone else.

  Which one is underlined follows the URL rather than any stored state: the
  customer side owns exactly one path, and everything else under /user is the
  demo account. That way a reload, a bookmark or the back button all agree with
  what is on screen, with nothing to keep in sync.
*/
export function PartnerSwitcher() {
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [text, setText] = useState(websiteCurrentLang.content.DublicatedText);
  useEffect(() => {
    setText(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const navigate = useNavigate();
  const { pathname } = useLocation();
  /*
    Without the admin's permission the customer half does not exist for this
    partner -- not disabled, absent. They see only the demo account.
  */
  const canManageCustomers = useCanManageCustomers();
  // Stays lit on a customer's profile, not just the list.
  const onCustomers = onCustomerSide(pathname);

  const go = (to) => () => {
    if (pathname !== to) navigate(to, { replace: true });
  };

  return (
    <div className={styles.switcher}>
      {canManageCustomers && (
        <span
          data-toggle="link"
          onClick={go(CUSTOMERS_PATH)}
          className={onCustomers ? styles.switch_selected : styles.switch_item}
          {...(onCustomers ? { "aria-current": "page" } : {})}
        >
          {text?.dublicatedText283}
        </span>
      )}
      <span
        data-toggle="link"
        onClick={go(DEMO_PATH)}
        className={onCustomers ? styles.switch_item : styles.switch_selected}
        {...(onCustomers ? {} : { "aria-current": "page" })}
      >
        {text?.dublicatedText284}
      </span>
    </div>
  );
}
